export default "__VITE_ASSET__B0X_t3Jf__"